// src/components/BoardPack/pages/consolidate_boardpack/toc_page.jsx
import React, { useContext } from "react";
import { SlideNavigationContext } from "../../common/SlideNavigationContext";

// TODO: pageNo values are placeholders — update to the real target page_no for each section.
const contents = [
  { id: 1, title: "Total Business Performance – All Companies", pageNo: 4 },
  { id: 2, title: "Mawgif KSA Performance", pageNo: 12 },
  { id: 3, title: "MIDCO Performance", pageNo: 19 },
  { id: 4, title: "BIDCO Performance", pageNo: 23 },
  { id: 5, title: "Total On Street Performance (KSA) – Parking & Enforcement", pageNo: 27 },
  { id: 6, title: "Total Off Street Performance (KSA) – Parking", pageNo: 94 },
  { id: 7, title: "Total Real Estate Performance", pageNo: 177 },
  { id: 8, title: "Total Sports – Other All", pageNo: 224 },
  { id: 9, title: "Total Airports – KSA, UAE, Jordan", pageNo: 228 },
  { id: 10, title: "Total Console – IFRIC-12", pageNo: 259 },
  { id: 11, title: "CFO Comments", pageNo: 261 },
  { id: 12, title: "Operation Director Comments", pageNo: 262 },
];

const Toc_Page = () => {
  const navigateToSlide = useContext(SlideNavigationContext);

  const handleClick = (pageNo) => {
    // slide index is 0-based, page_no is 1-based
    navigateToSlide(pageNo - 1);
  };

  return (
    <div className="px-6">
      <div className="text-left">
        <h2 className="text-4xl font-semibold text-[#006fc0]">
          <span className=" !border-b-4">Contents</span>
        </h2>
      </div>

      <div className="w-full max-w-3xl bg-[#006fc0] rounded-[80px] py-8 px-2 mt-5">
        {contents.map((content) => (
          <div key={content.id} className="flex items-center px-5">
            <span className="text-[20px] text-white w-8 text-right">{content.id}.</span>
            <span
              onClick={() => handleClick(content.pageNo)}
              className="!border-b-2 text-white text-[20px] ml-3 cursor-pointer hover:text-[#cfe8ff]"
            >
              {content.title}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Toc_Page;
